$(document).ready(function(){

    //On met la fenetre et les elements a checker dans des variables
    var $small_moving_elements 	= $('[data-scroll-interaction]');
    var $window 				= $(window);
    var throttleDelay 			= 30;

    // On lance le check au scroll,
    $window.on('scroll resize', $.throttle( throttleDelay, true, function(){
        check_if_in_view($small_moving_elements, 0, false);
    }));
    // et on déclenche un premier check au chargement de la page
    $window.scroll();

    ////////////////// ON CONTROLE QUELLE SECTION EST AFFICHEE //////////////////

    ///////// FONCTION QUI CONTROLE QUELLE SECTION EST VISUALISÉE
    // Param 1 : Liste d'éléments a checker,
    // Param 2 : Hauteur à partir du bas de l'écran pour le déclenchement de l'effet (Pourcentage)
    // Param 3 : Classe a appliquer une fois dans la vue.
    function check_if_in_view(scroll_elements, view_percentage, active_class)
    {
        // On récupère la hauteur de la fenetre
        var window_height = $window.height();
        // On récupère la position du scroll par rapport au haut de page
        var window_top_position = $window.scrollTop();
        // On récupère la position du scroll par rapport au bas de page
        var window_bottom_position = (window_top_position + window_height);
        // On récupère la position du scroll par rapport au millieu de page
        var window_trigger_position = (window_top_position + (window_height * ((100 - view_percentage) / 100)));

        // Pour chaque élément du scroll
        $.each(scroll_elements, function() {
            var $element = $(this);
            var element_height = $element.outerHeight();
            var element_top_position = $element.offset().top;
            var element_bottom_position = (element_top_position + element_height);

            // Si le bloc actuel est dans le viewport
            if ((element_bottom_position >= window_trigger_position) &&
            (element_top_position <= window_trigger_position)) {
                if (active_class){
                    // On a joute la classe "in-view" à l'element actif
                    $element.addClass(active_class);
                }
                // On update son data-checkview pour dire qu'on l'a déjà affiché au moins une fois
                $element.attr("data-check-if-in-view", "checked");
            }
            // Si le bloc actuel est déjà passé mais pas dans le viewport actuel
            else if ((element_bottom_position < window_trigger_position)){
                $element.attr("data-check-if-in-view", "checked");

                if (active_class){
                    $element.removeClass(active_class);
                    $element.attr(active_class);
                }
            }
            else {
                if (active_class){
                    $element.removeClass(active_class);
                }
            }
            // on declenche l'evenement custom "inViewChange" pour signaler qu'il y a eu changement
            // et déclencher d'autres trucs plus tard si besoin, sans besoin de surveiller à nouveau le scroll pour ça
            $element.trigger('inViewChange');
        });

    }
    
});
